var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkOut18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "yxg7w8cdda"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#yxg7w8cdda)",
    transform: "translate(-311 -347) translate(0 50) translate(267 82) translate(0 71) translate(24 130) translate(20 9) translate(0 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A7070",
    d: "M6.513 4.125c.484 0 .875.392.875.875s-.391.875-.875.875H2.88c-.069 0-.125.056-.125.125v9.12c0 .069.056.125.125.125H12c.069 0 .125-.056.125-.125v-3.633c0-.484.392-.875.875-.875s.875.391.875.875v3.633c0 1.036-.84 1.875-1.875 1.875H2.88c-1.036 0-1.875-.84-1.875-1.875V6c0-1.036.84-1.875 1.875-1.875h3.633zm9.357-3.12c.58 0 1.057.439 1.118 1.002l.007.123v5.99c0 .483-.392.875-.875.875-.446 0-.814-.334-.868-.765l-.007-.11V3.992l-7.159 7.16c-.313.313-.805.339-1.148.078l-.09-.079c-.313-.313-.339-.804-.078-1.147l.079-.09 7.158-7.159H9.88c-.446 0-.814-.334-.868-.765l-.007-.11c0-.446.334-.814.765-.868l.11-.007h5.99z"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOut18);
export default __webpack_public_path__ + "static/media/link-out-18.9589f3f927c49ae562e3c2e974794ef2.svg";
export { ForwardRef as ReactComponent };